import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IPagedList } from '@brafton/common-framework-library';

@Component({
  selector: 'shared-filter-results-count',
  templateUrl: './filter-results-count.component.html',
  styleUrls: ['./filter-results-count.component.scss'],
  host: { class: 'shared-filter-results-count' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedFilterResultsCountComponent {
  @Input() results!: IPagedList<any>;
  @Input() filtered = false;
  @Input() objectName = 'Projects';
}
